export default __webpack_public_path__ + "static/media/2_Still.4311be6b.jpg";